// Arlington seed builder (BACKEND / runtime `CITY=arlington`).
//
// Turns each entry in ARLINGTON_SPRAYGROUNDS into a crowd-reportable `Pool`
// (the same contract DC's shared/seed-pools.ts produces), so the existing
// status/report/repo machinery works unchanged. Sister of SEED_POOLS; consumed
// by scripts/seed.ts when `process.env.CITY === "arlington"`.
//
// Each sprayground →
//   kind:"splash", poolId:"splash-<id>", reported on the `main` section,
//   hasKiddiePool:false, indoor:false, ward:0 (Arlington has no wards),
//   one SeasonWindow (ARLINGTON_SPLASH_SEASON start/end) whose `main.days` are
//   the entry's weekly `days`.
// Mosaic (closedForSeason) → empty `seasons` + closedForSeason:true (reads
//   out-of-season everywhere; renders as a non-reportable "closed" card).

import type { Pool, SeasonWindow } from "./types";
import { ARLINGTON_SPRAYGROUNDS, ARLINGTON_SPLASH_SEASON } from "./arlington-spraygrounds";

export function buildArlingtonSeedPools(): Pool[] {
  return ARLINGTON_SPRAYGROUNDS.map((s) => {
    const base = {
      poolId: `splash-${s.id}`,
      name: s.name,
      address: s.address,
      ward: 0,
      lat: s.lat,
      lng: s.lng,
      kind: "splash" as const,
      hasKiddiePool: false,
      indoor: false,
    };

    if (s.closedForSeason) {
      return { ...base, seasons: [], closedForSeason: true };
    }

    const season: SeasonWindow = {
      start: ARLINGTON_SPLASH_SEASON.start,
      end: ARLINGTON_SPLASH_SEASON.end,
      main: { days: s.days },
    };
    return { ...base, seasons: [season] };
  });
}

/** The Arlington catalog as reportable splash Pools (sister of SEED_POOLS). */
export const ARLINGTON_SEED_POOLS: Pool[] = buildArlingtonSeedPools();
